import SettingsContainer from './SettingsContainer.js'
import SettingsView from 'modules/settings/SettingsView.js'
import React from 'react'

const SettingsPage = () => {
	return <SettingsContainer>{SettingsView}</SettingsContainer>
}

export default SettingsPage
